import { baseURL } from "../utilits/config";
import axios from "axios";

export function addborders(borderData, callback) {
  const config = {
    method: "post",
    url: baseURL + "/add-borders",
    headers: {
      "Content-Type": "application/json",
    },
    data: borderData,
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getborders(callback) {
  const config = {
    method: "get",
    url: baseURL + "/add-borders",
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}
